import React, { useRef, useState, useEffect } from "react";
import HrnbLink from "./HrnbLink";
import HrnbButton from "./HrnbButton";
import "../../css/components/controls/HrnbNavbarDropdown.css";

export default function HrnbNavbarDropdown({ 
    label, 
    icon, 
    items = [], 
    active = false 
}) {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const onDocClick = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", onDocClick);
        return () => document.removeEventListener("mousedown", onDocClick);
    }, []);

    return (
        <div className="hrnb-navbar-dropdown" ref={dropdownRef}>
            <HrnbLink
                to="#"
                icon={icon}
                className={`hrnb-navbar-dropdown__trigger ${isOpen ? "hrnb-navbar-dropdown__trigger--open" : ""}`}
                onClick={(e) => {
                    e.preventDefault();
                    setIsOpen(!isOpen);
                }}
            >
                {label}
                <span className="hrnb-navbar-dropdown__arrow">▼</span>
            </HrnbLink>

            {isOpen && (
                <div className="hrnb-navbar-dropdown__menu">
                    {items.map((item) => (
                        <HrnbLink
                            key={item.to}
                            to={item.to}
                            icon={item.icon}
                            className="hrnb-navbar-dropdown__item"
                            onClick={() => setIsOpen(false)}
                        >
                            {item.label}
                        </HrnbLink>
                    ))}
                </div>
            )}
        </div>
    );
}
